import { render, staticRenderFns } from "./SmallMicroEnterprises.vue?vue&type=template&id=06aa90d6&scoped=true"
import script from "./SmallMicroEnterprises.vue?vue&type=script&lang=js"
export * from "./SmallMicroEnterprises.vue?vue&type=script&lang=js"
import style0 from "./SmallMicroEnterprises.vue?vue&type=style&index=0&id=06aa90d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06aa90d6",
  null
  
)

export default component.exports